import { INSIGHTS_API_BASE_URL } from '../../constants'

export const insightsReportUrl = (slug: string): string | undefined => {
  const base = INSIGHTS_API_BASE_URL?.replace(/\/$/, '')
  if (!base) {
    return undefined
  }
  return `${base}/html-reports/${encodeURIComponent(slug)}`
}

export const matchesHtmlReport = (report: {
  label: string
  description: string
  slug: string
  tags: string[]
}, query: string): boolean => {
  const term = query.trim().toLowerCase()
  if (!term) {
    return true
  }
  const haystack = [report.label, report.description, report.slug, ...report.tags]
    .join(' ')
    .toLowerCase()
  return haystack.includes(term)
}
